<template>
  <div class="header">
    <MobileSubMenu
      v-if="
        commonStore.isMobile &&
        router.currentRoute.value.name !== ROUTE_NAME.ReservationTimeList &&
        router.currentRoute.value.name !== ROUTE_NAME.NewPasswordAccount
      "
      ref="header"
    />
    <DesktopSubMenu v-if="commonStore.isDesktop" ref="header" />
  </div>
</template>

<script setup lang="ts">
import { useCommonStore } from '@stores';
import MobileSubMenu from '@components/common/MobileSubMenu.vue';
import DesktopSubMenu from '@components/common/DesktopSubMenu.vue';
import router from '@infra/router';
import { ROUTE_NAME } from '@constants';

const commonStore = useCommonStore();
</script>

<style scoped lang="scss">
.header {
  padding-top: 88px;
}
</style>
